import { useEffect, useState } from 'react';
import axios from 'axios';
import { API, LOCATIONS, SIBLINGS } from '../data/content';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Pillars } from '../components/Pillars';
import { Siblings } from '../components/Siblings';
import { TownMap } from '../components/TownMap';
import { Footer } from '../components/Footer';

export default function Home() {
  const [content, setContent] = useState({ siblings: SIBLINGS, locations: LOCATIONS });

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#190A0B]" data-testid="corporate-page">
      <div className="candle-glow" aria-hidden="true" />
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Pillars />
        <Siblings siblings={content.siblings} />
        <TownMap locations={content.locations} />
      </main>
      <Footer />
    </div>
  );
}
